/* USE PROTECTION design - BLACK FRIDAY MODE: behaviour of the BF surfaces. Loaded (defer) by snippets/up-bf-head, so
   it exists only while the header's "Black Friday mode" switch is on and html.u-bf is stamped. ES5 on purpose (no build
   step, same as up.js / mf-track.js). Panels open and close through assets/up.js (data-u-open / data-u-close).
   1. Sheet parts  - a card with data-u-open + data-u-sec (home band: car / mystery) shows only that part of the sheet
                     ([data-u-bfsec]), as the mockup's data-sec; opened any other way the sheet shows every part. The
                     giveaway page's own cards are assets/up-pages.js's ([data-u-win]), left alone here. A tap on the
                     header bar closes the home sheet, as the scrim does (the bar sits above the scrim).
   2. Order copy   - [data-u-cc]: the car lines ask to finish the order once the cart holds a case or a protector
                     (the mockup's data-cc). The count is the drawer's own (#mini-cart [data-u-count], snippets/up-cart:
                     cases + protectors, never the gift), re-read whenever theme.js re-renders the drawer.
   3. Phone        - [data-u-bf-dev] links ("Alege-ți husa") go to the remembered phone's collection (localStorage
                     mf_dev1, assets/mf-device.js), the same way assets/up-cart.js points the empty cart's button.
   4. Card chip    - cards built in the browser (the search sheet, assets/up-search.js) get the "Mystery Gift" chip that
                     snippets/up-card prints on the server: all-cases cards (data-p11="1"), while the gift is in stock
                     (data-mg on the strip template); their "1+1 cadou" chip is hidden by assets/up-skin-bf.css.
   5. Steps        - [data-u-bf-step="<name>"] -> mf_nav_step bf:<name> through mfTrackPush (assets/mf-track.js). */
(function () {
  'use strict';
  var W = window, D = document;
  if (!D.documentElement.classList.contains('u-bf')) { return; }

  function each(list, fn) { for (var i = 0; i < list.length; i++) { fn(list[i], i); } }
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  /* ── 1. sheet parts ─────────────────────────────────────────────────────── */
  function showPart(panel, sec) {
    each(panel.querySelectorAll('[data-u-bfsec]'), function (x) { x.hidden = !!sec && x.getAttribute('data-u-bfsec') !== sec; });
    var body = panel.querySelector('.u-p-body'); if (body) { body.scrollTop = 0; }
  }
  /* capture: before assets/up.js opens the sheet and moves the focus into it */
  D.addEventListener('click', function (e) {
    var o = closest(e.target, '[data-u-open]'); if (!o || closest(o, '[data-u-win]')) { return; }
    var p = D.getElementById(o.getAttribute('data-u-open'));
    if (!p || !p.querySelector('[data-u-bfsec]')) { return; }
    showPart(p, o.getAttribute('data-u-sec') || '');
  }, true);
  D.addEventListener('click', function (e) {
    var sheet = D.querySelector('#bfinfo.u-bf-sheet.u-on');
    if (!sheet || !W.upPanel || !closest(e.target, 'store-header.header')) { return; }
    e.preventDefault(); e.stopPropagation(); W.upPanel.close();
  }, true);

  /* ── 2. order copy ──────────────────────────────────────────────────────── */
  function count() {
    var c = D.querySelector('#mini-cart [data-u-count]');
    if (c) { return parseInt(c.getAttribute('data-u-count'), 10) || 0; }
    var tv = W.themeVariables && W.themeVariables.settings;
    return (tv && tv.cartCount) || 0;
  }
  function copy() {
    var n = count();
    each(D.querySelectorAll('[data-u-cc]'), function (el) {
      if (!el.hasAttribute('data-u-cc0')) { el.setAttribute('data-u-cc0', el.textContent); }
      var t = n > 0 ? el.getAttribute('data-u-cc') : el.getAttribute('data-u-cc0');
      if (el.textContent !== t) { el.textContent = t; }
    });
  }

  /* ── 3. the remembered phone ────────────────────────────────────────────── */
  function phone() {
    var o = null;
    try { o = JSON.parse(W.localStorage.getItem('mf_dev1') || 'null'); } catch (e) { o = null; }
    if (!o || o.v !== 1 || !o.u) { return; }
    if (o.t && (new Date().getTime() - o.t) > 15552000000) { return; }
    var path = String(o.u).split('?')[0].split('#')[0].replace(/\/+$/, '');
    if (!/^\/collections\/[^\/]+$/.test(path)) { return; }
    var href = W.mfHref ? W.mfHref(path) : path;
    each(D.querySelectorAll('a[data-u-bf-dev]'), function (a) { a.setAttribute('href', href); });
  }

  /* ── 4. the Mystery Gift chip on browser-built cards ─────────────────────── */
  /* off since 2026-11-04 (owner: "sok a mystery, a badge, árak egyben, tehát csak az eredeti ár, a mostani ár és a %
     badge kell"): no gift chip on any card, server-built (snippets/up-card) or browser-built */
  var mg = false;
  function chips(root) {
    if (!mg || !root || !root.querySelectorAll) { return; }
    each(root.querySelectorAll('a.u-card[data-p11="1"] .u-row'), function (row) {
      if (row.querySelector('[data-u-bf-mg]')) { return; }
      var s = D.createElement('span');
      s.className = 'u-chip'; s.setAttribute('data-u-bf', ''); s.setAttribute('data-bf', 'on'); s.setAttribute('data-u-bf-mg', '');
      /* the store's word for the gift (the key snippets/up-card prints on the server); the brand name if it is missing */
      s.textContent = (W.mfT && W.mfT('up.cart.gift_name')) || 'Mystery Gift';
      row.appendChild(s);
    });
  }

  /* ── 5. steps ───────────────────────────────────────────────────────────── */
  D.addEventListener('click', function (e) {
    var t = closest(e.target, '[data-u-bf-step]'); if (!t) { return; }
    var name = String(t.getAttribute('data-u-bf-step') || '').replace(/[^a-z0-9_]/gi, '_').slice(0, 36);
    try { if (name && typeof W.mfTrackPush === 'function') { W.mfTrackPush('mf_nav_step', { mf_step: 'bf:' + name }); } } catch (err) {}
  }, true);

  /* ── boot + re-runs: theme.js replaces the drawer's innerHTML on every cart:refresh, and the search sheet and the
     list loaders add cards later, so one observer re-applies 2 and 4 to what changed ─────────────────────────────── */
  function run() { copy(); phone(); chips(D); }
  var queued = false;
  function later() { if (queued) { return; } queued = true; setTimeout(function () { queued = false; copy(); chips(D); }, 60); }
  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', run); } else { run(); }
  if ('MutationObserver' in W) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) { if (ms[i].addedNodes && ms[i].addedNodes.length) { later(); return; } }
    }).observe(D.body || D.documentElement, { childList: true, subtree: true });
  }
  D.addEventListener('shopify:section:load', run);
})();
